import { get, omit, set } from 'lodash'
import { AnalyticsTree, AnalyticsPreparedTree } from './types'
import { AnalyticsField } from '@/store/analytics/utils/enums'

const PATH_SEPARATOR = '/'

export const adjustTreeByOwnership = <T extends AnalyticsTree>(
  data?: T[],
): T[] | undefined => {
  if (!data?.length) return data

  const amountByPath = new Map<string, number>()
  for (const item of data) {
    const amount = item.amount
    if (typeof amount === 'number' && Number.isFinite(amount)) {
      amountByPath.set(item.path.join(PATH_SEPARATOR), amount)
    }
  }

  return data.map(item => {
    let factor = 1
    for (let i = 1; i < item.path.length; i++) {
      const ancestorId = item.path[i - 1]
      if (ancestorId === AnalyticsField.REPO_ROOT) continue

      const ancestorAmount = amountByPath.get(
        item.path.slice(0, i).join(PATH_SEPARATOR),
      )
      if (typeof ancestorAmount === 'number' && Number.isFinite(ancestorAmount)) {
        factor *= ancestorAmount
      }
    }

    const adjustedAmount = Number.isFinite(item.amount) ? item.amount * factor : item.amount
    const adjustedBalance = Number.isFinite(item.balance) ? item.balance * factor : item.balance

    return {
      ...item,
      amount: adjustedAmount,
      balance: adjustedBalance,
    }
  })
}

export const prepareTree = (data?: AnalyticsTree[]) => {
  if (!data?.length) return
  const result: AnalyticsPreparedTree = {}
  for (let i = 0; i < data.length; i++) {
    const { path } = data[i]
    set(result, path, { ...data[i] })
  }
  return result
}

export const getTreeFilterableNodes = (
  data?: AnalyticsTree[],
  tree?: AnalyticsPreparedTree,
) => {
  if (!data?.length) return []
  const result = data.reduce((acc, item) => {
    const node = get(tree, item.path)
    const children = omit(node, 'path', AnalyticsField.AMOUNT, 'balance')
    const isLeaf = !Object.keys(children).length
    if (!isLeaf) {
      acc.push(item.path)
    }
    return acc
  }, [] as string[][])
  return result
}
